import { DEFAULT_APP_STORE_URL } from '../constants/appInfo';

export const openAppStoreLink = () => {
  window.open(DEFAULT_APP_STORE_URL, '_blank', 'noopener,noreferrer');
};

export type ScopeType = {
  classroomFolder?: string;
  post?: string;
  user?: string;
  activity?: string;
  classroom?: string;
  team?: string;
  gameSet?: string;
  gameCollection?: string;
  game?: string;
  slideshow?: string;
  certificate?: string;
  reportCase?: string;
};
/**
 * Build resource scopes for some backend requests.
 * @param param object of inputs, order is important
 * @returns scope in string
 */
export const getScope = ({
  classroomFolder,
  post,
  user,
  activity,
  classroom,
  team,
  gameSet,
  gameCollection,
  game,
  slideshow,
  certificate,
  reportCase,
}: ScopeType) => {
  return Object.entries({
    reportCase,
    classroomFolder,
    post,
    user,
    activity,
    classroom,
    team,
    gameSet,
    gameCollection,
    game,
    slideshow,
    certificate,
  })
    .filter((value): value is [string, string] => typeof value === 'string')
    .reduce((acc, cur, index) => {
      return acc + (index === 0 ? '' : ':') + cur[0] + '_' + cur[1];
    }, '');
};
